<template>
  <modal v-bind="modalParams">
    <div class="exchange-rate">
      <div class="exchange-rate-wrapper">
        <div class="header">
          <img @click="handleAction('cancel')" :src="staticImg.CrossBlue" />
          <p>{{ $t('inputAmount') }}</p>
        </div>
        <div class="content">
          <!-- 切换类型 -->
          <div class="tab" v-if="byAmount && byStages">
            <div v-if="byAmount" @click="changeType(BYA)" :class="tabLeftClass">
              <p>{{ $t('byAmount') }}</p>
            </div>
            <div v-if="byStages" @click="changeType(BYS)" :class="tabRightClass">
              <p>{{ $t('byDueDate') }}</p>
            </div>
          </div>
          <!-- 按金额 -->
          <div class="amount" v-show="type === BYA">
            <div :class="amoutClass">
              <div class="input-header">
                <img :src="flags[iCurrency] || staticImg[iCurrency]" />
                <p>{{ iCurrency }}</p>
              </div>
              <input
                ref="input"
                placeholder="0"
                type="text"
                v-model="iAmount"
                @input="onChange"
                @blur="onBlur"
                @focus="onFocus"
                class="input-value"
              />
              <div v-if="needTips" class="input-tips">
                <p>{{ $t('levy') }}</p>
              </div>
            </div>
            <div
              ref="error"
              v-show="isError"
              :class="[isError ? 'input-error' : 'input-error-empty']">
              <p>{{ errorText }}</p>
            </div>
            <div class="input-rate" v-if="dCurrency !== HKD">
              <div class="rate-header">
                <div class="rate-left">
                  <img :src="flags[tCurrency] || staticImg[tCurrency]" />
                  <p>{{ `${tCurrency} ${tAmount}` }}</p>
                </div>
                <img @click="switchCurrency" class="rate-right" :src="staticImg.Switch" />
              </div>
              <div class="rate-footer">
                <p>{{ rateText }}</p>
              </div>
            </div>
          </div>
          <!-- 按分期 -->
          <div class="amount" v-show="type === BYS">
            <div class="input-amount">
              <div class="input-header">
                <img :src="flags[nCurrency] || staticImg[nCurrency]" />
                <p>{{ nCurrency }}</p>
              </div>
              <input
                class="input-value"
                :value="cCommasAmount"
                type="text"
                disabled
              />
            </div>
            <div class="input-footer">
              <p>{{ $t('premDeducted') }}</p>
            </div>
            <div class="input-rate" v-if="dCurrency !== HKD">
              <div class="rate-header">
                <div class="rate-left">
                  <img :src="flags[pCurrency] || staticImg[pCurrency]" />
                  <p>{{ `${pCurrency} ${pCommasAmount}` }}</p>
                </div>
                <img @click="switchCurrency" class="rate-right" :src="staticImg.Switch" />
              </div>
              <div class="rate-footer">
                <p>{{ rateText }}</p>
              </div>
            </div>
            <div class="due-date-wrapper">
              <div class="due-date">
                <img
                  :src="staticImg.Left"
                  :class="{'no-active': cTerms <= minterms || isOneMode}"
                  @click="reduceTerms" />
                <p>{{ `${cTerms} ${$t('terms')}` }}</p>
                <img
                  :src="staticImg.Right"
                  :class="{'no-active': cTerms >= maxterms || isOneMode}"
                  @click="addTerms" />
              </div>
            </div>
          </div>
          <div @click="handleAction('confirm')" :class="confirmClass">
            <p>
              {{ $t('confirm') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from '../Modal'
import i18nSetting from '@/utils/languageSet'
import LangConfig from '@/locale/export/exchangeRate.js'
import { Cross_blue } from '@/images/myCard'
import { Flag_HK, Flag_US, Flag_OMA, Switch, Glyphs_Left, Glyphs_Right } from '@/images'
import utils from '@/utils/utils'
import mixins from '@/utils/mixins'
const { addThousands, removeThousands, toFixed, isIOS, getCursorPosition, setCaretPosition } = utils
const toCeil = (num, s) => toFixed(num, s, 'ceil')
const toFloor = (num, s) => toFixed(num, s, 'floor')
const $i18n = i18nSetting(LangConfig)
const HKD = 'HKD'
const MOP = 'MOP'
const USD = 'USD'
const GBP = 'GBP'
const SGD = 'SGD'
const RMB = 'RMB'
const CAD = 'CAD'
const AUD = 'AUD'
const BYA = 1
const BYS = 2
export default {
  components: {
    Modal
  },
  mixins: [mixins],
  data () {
    return {
      modalParams: {
        showModal: false,
        lockScroll: true
      },
      value: false,
      payamount: '',
      tpayamount: '',
      rate: 0,
      type: BYA,
      HKD,
      MOP,
      USD,
      BYA,
      BYS,
      staticImg: {
        Switch,
        CrossBlue: Cross_blue,
        Left: Glyphs_Left,
        Right: Glyphs_Right,
        [HKD]: Flag_HK,
        [MOP]: Flag_OMA,
        [USD]: Flag_US
      },
      types: [BYA, BYS],
      dCurrency: '', // 默认货币
      // 按金额和按分期各维护自己状态
      // 按金额
      iRate: false, // 汇率(HKD 1.0)
      iAmount: '', // 当前金额
      iCurrency: '', // 当前货币
      tAmount: '', // 转换金额
      tCurrency: '', // 转换货币
      minAmount: -Infinity, // 最小金额
      maxAmount: Infinity, // 最大金额
      // 按分期
      nRate: 0, // 汇率
      minterms: 0, // 最小分期数
      maxterms: 1, // 最大分期数
      terms: [], // 分期金额数组
      pTerms: [], // 转换分期金额数组
      cTerms: 0, // 当前分期数
      nCurrency: '', // 当前货币
      pCurrency: '', // 转换货币,
      needTips: false, /// 展示征费
      flags: {
        [HKD]: '',
        [MOP]: '',
        [GBP]: '',
        [USD]: '',
        [SGD]: '',
        [RMB]: '',
        [CAD]: '',
        [AUD]: ''
      },
      isOneMode: false
    }
  },
  computed: {
    iNumAmount () {
      // 去除千分号的iAmount
      return removeThousands(this.iAmount) - 0
    },
    tNumAmount () {
      // 去除千分号的tAmount
      return removeThousands(this.tAmount) - 0
    },
    cCommasAmount () {
      // 根据当前分期数找出分期金额
      const index = this.findAmountIndex()
      return this.terms[index] ? addThousands(this.terms[index].required_prem) : 0
    },
    pCommasAmount () {
      // 根据当前分期数找出转换分期金额
      const index = this.findAmountIndex()
      return this.pTerms[index] ? addThousands(this.pTerms[index].required_prem) : 0
    },
    byAmount () {
      return this.types.indexOf(BYA) !== -1
    },
    byStages () {
      return this.types.indexOf(BYS) !== -1
    },
    rateText () {
      return this.$t('rateText')
        .replace('{currency}', this.dCurrency)
        .replace('{rate}', this.rate.toFixed(5))
    },
    tNumMinAmount () {
      if (this.minAmount === 0.01) return 0.01
      return toCeil(this.minAmount * this.rate, 2)
    },
    tNumMaxAmount () {
      return toCeil(this.maxAmount * this.rate, 2)
    },
    tMinAmount () {
      return addThousands(Number(this.tNumMinAmount).toFixed(2))
    },
    tMaxAmount () {
      return addThousands(Number(this.tNumMaxAmount).toFixed(2))
    },
    iMinAmount () {
      return addThousands(this.minAmount.toFixed(2))
    },
    iMaxAmount () {
      return addThousands(this.maxAmount.toFixed(2))
    },
    lessMinAmount () {
      if (isNaN(this.iNumAmount)) return true
      if (this.iCurrency === this.dCurrency) {
        return this.iNumAmount < this.minAmount
      } else {
        return this.iNumAmount < this.tNumMinAmount
      }
    },
    moreMaxAmount () {
      if (this.iCurrency === this.dCurrency) {
        return this.iNumAmount > this.maxAmount
      } else {
        return this.iNumAmount > this.tNumMaxAmount
      }
    },
    isError () {
      return this.lessMinAmount || this.moreMaxAmount
    },
    errorText () {
      if (this.lessMinAmount) {
        const min = this.iCurrency === this.dCurrency ? this.iMinAmount : this.tMinAmount
        return this.$t('minTips').replace('{text}', `${this.iCurrency} ${min}`)
      } else if (this.moreMaxAmount) {
        const max = this.iCurrency === this.dCurrency ? this.iMaxAmount : this.tMaxAmount
        return this.$t('maxTips').replace('{text}', `${this.iCurrency} ${max}`)
      }
      return ''
    },
    noConfirm () {
      if (this.type === BYS) return false
      return this.isError
    },
    tabLeftClass () {
      return {
        'tab-left': true,
        'tab-active': this.type === BYA
      }
    },
    tabRightClass () {
      return {
        'tab-right': true,
        'tab-active': this.type === BYS
      }
    },
    amoutClass () {
      return {
        'input-amount': true,
        'input-amount-error': this.isError
      }
    },
    confirmClass () {
      return {
        'confirm-btn': true,
        'comfirm-disabled': this.noConfirm
      }
    }
  },
  watch: {
    value (newVal) {
      this.modalParams.showModal = newVal
      this.initData()
      if (newVal) {
        if (this.byAmount) {
          this.initAmount()
        }
        if (this.byStages) {
          this.initStage()
        }
      }
    }
  },
  created () {
    Object.defineProperty(this, '$t', {
      value: this.$t.bind({ $i18n }),
      enumerable: false,
      configurable: true,
      writable: true
    })
  },
  methods: {
    onFocus () {
      this.iAmount = removeThousands(this.iAmount)
      this.prevInput = this.iAmount
    },
    onBlur () {
      if (this.iAmount === '.') {
        this.iAmount = 0
      }
      this.iAmount = addThousands(Number(this.iAmount).toFixed(2))
      this.fixIOS()
    },
    fixIOS () {
      if (isIOS()) {
        setTimeout(() => {
          const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        }, 0)
      }
    },
    initData () {
      // 初始化数据
      this.minAmount = Number(removeThousands(this.minAmount))
      this.maxAmount = Number(removeThousands(this.maxAmount))
      if (!this.byAmount && !this.byStages) {
        this.types = [BYA, BYS]
        this.type = BYA
      } else if (this.types.indexOf(this.type) === -1) {
        if (this.byAmount) this.type = BYA
        else if (this.byStages) this.type = BYS
      }
    },
    initAmount () {
      // 按金额
      this.iAmount = addThousands(this.payamount.toFixed(2))
      if (this.iCurrency !== HKD) {
        this.iRate = true
        this.tCurrency = HKD
      } else {
        this.iRate = false
        this.tCurrency = this.dCurrency
      }
      if (this.tpayamount) {
        this.tAmount = addThousands(this.tpayamount)
      } else {
        this.amountChange()
      }
      this.fixIOS()
    },
    initStage () {
      // 按分期

      if (this.nCurrency !== HKD) {
        this.nRate = true
        this.pCurrency = HKD
      } else {
        this.nRate = false
        this.pCurrency = this.dCurrency
      }
      this.pTerms.splice(0, this.pTerms.length)
      this.terms.forEach((item, i) => {
        this.pTerms.push({
          terms: item.terms,
          required_prem: this.nRate ? toCeil(item.required_prem * this.rate, 2)
            : toFloor(item.required_prem / this.rate, 2)
        })
      })
    },
    onChange (event) {
      const val = event.target.value.replace(/[^\d.]/g, '')
      const dotNum = val.match(/[.]/g)
      const dotPos = val.indexOf('.') + 1
      if (dotNum && dotNum.length === 2) {
        this.iAmount = this.prevInput
      } else if (dotPos && val.length - dotPos > 2) {
        this.iAmount = this.prevInput
      } else {
        this.iAmount = val
        this.prevInput = this.iAmount
      }
      const input = this.$refs.input
      const prevLen = event.target.value.length
      const nextLen = this.iAmount.length
      let start = getCursorPosition(input)
      if (nextLen > prevLen) {
        start++
      } else if (nextLen < prevLen) {
        start--
      }
      setTimeout(() => {
        setCaretPosition(input, start)
      }, 0)
      this.amountChange()
    },
    amountChange () {
      // 转换金额
      if (this.iRate) {
        this.tAmount = addThousands(toCeil(this.iNumAmount * this.rate, 2))
      } else {
        this.tAmount = addThousands(toCeil(this.iNumAmount / this.rate, 2))
      }
    },
    switchCurrency () {
      /// 切换调转当前和展示数据
      if (this.type === BYA) {
        this.iRate = !this.iRate;
        [this.iAmount, this.iCurrency, this.tAmount, this.tCurrency] =
        [this.tAmount, this.tCurrency, this.iAmount, this.iCurrency]
      } else if (this.type === BYS) {
        [this.nCurrency, this.pCurrency, this.terms, this.pTerms] =
        [this.pCurrency, this.nCurrency, this.pTerms.slice(), this.terms.slice()]
      }
    },
    changeType (type) {
      this.type = type
    },
    findAmountIndex () {
      // 找出当前分期数组的索引
      for (let i = 0; i < this.terms.length; i++) {
        if (this.terms[i].terms === this.cTerms) {
          return i
        }
      }
    },
    reduceTerms () {
      if (this.cTerms <= this.minterms || this.isOneMode) return
      this.cTerms--
      if (this.findAmountIndex() === undefined) {
        this.reduceTerms()
      }
    },
    addTerms () {
      if (this.cTerms >= this.maxterms || this.isOneMode) return
      this.cTerms++
      if (this.findAmountIndex() === undefined) {
        this.addTerms()
      }
    },
    handleAction (action) {
      if (action === 'cancel') {
        this.value = false
        this.callback({ action })
        return
      }
      if (this.noConfirm) return
      this.value = false
      let data = {
        action
      }
      if (this.type === BYA) {
        data = {
          action,
          type: this.type,
          currency: this.iCurrency,
          payamount: this.iNumAmount,
          ex_currency: this.tCurrency,
          ex_payamount: this.tNumAmount
        }
      } else if (this.type === BYS) {
        const index = this.findAmountIndex()
        const payamount = Number(this.terms[index] ? this.terms[index].required_prem : 0)
        const ex_payamount = Number(this.pTerms[index] ? this.pTerms[index].required_prem : 0)
        data = {
          action,
          payamount,
          ex_payamount,
          type: this.type,
          cTerms: this.cTerms,
          terms: this.terms,
          currency: this.nCurrency,
          ex_currency: this.pCurrency
        }
      }
      this.callback(data)
    }
  }
}
</script>
<style lang="scss" scoped>
.exchange-rate {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .exchange-rate-wrapper {
    width: 315px;
    border-radius: 4px;
    background-color: $color-bg-white;
    .header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 44px;
      @include border-bottom;
      img {
        position: absolute;
        top: 10px;
        left: 13px;
        width: 24px;
        height: 24px;
      }
      p {
        color: $color-text;
        font-size: $base-font-size;
        line-height: 22px;
        text-align: center;
        @include font-Medium;
      }
    }
    .content {
      padding: 15px;
      .tab {
        display: flex;
        flex-direction: row;
        margin-bottom: 20px;
        border: 1px solid $color-primary;
        border-radius: 4px;
        overflow: hidden;
        .tab-left,
        .tab-right {
          flex: 1;
          padding: 9px;
          background-color: $color-bg-white;
        }
        .tab-active {
          background-color: $color-primary;
          p {
            color: $color-bg-white;
          }
        }
        p {
          color: $color-primary;
          font-size: $span-font-size;
          line-height: 14px;
          text-align: center;
          @include font-Medium;
        }
      }
      .amount {
        .input-amount {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 10px 10px 5px;
          background-color: $color-stage1;
          @include border-all(8px);
          .input-header {
            display: flex;
            flex-direction: row;
            align-items: center;
            img {
              width: 25px;
              height: 17px;
              margin-right: 10px;
            }
            p {
              color: $color-text;
              font-size: $base-font-size;
              line-height: 22px;
            }
          }
          .input-value {
            z-index: 1000;
            margin-top: 6px;
            color: $color-text;
            font-size: $large-font-size;
            line-height: 26px;
            background-color: $color-stage1;
            caret-color: $color-primary;
            @include font-Medium;
            &::placeholder {
              color: $color-stage3;
              font-size: $large-font-size;
              line-height: normal;
              @include font-Medium;
            }
            &:disabled {
              color: $color-text;
              opacity: 1;
              -webkit-text-fill-color: $color-text;
            }
          }
          .input-tips {
            position: absolute;
            top: 10px;
            right: 10px;
            p {
              color: $color-stage5;
              font-size: $little-font-size;
              line-height: 16.8px;
              transform: scale(0.833);
              transform-origin: right top;
            }
          }
        }
        .input-footer {
          p {
            margin-top: 3px;
            margin-bottom: -$little-font-size;
            color: $color-stage5;
            font-size: $little-font-size;
            line-height: 16.8px;
          }
        }
        .input-amount-error {
          @include border-all(8px, $color-status-user-error);
        }
        .input-error {
          margin-bottom: -15px;
          padding: 3px 0 3px 10px;
          p {
            position: relative;
            width: calc(100% / 0.833);
            color: $color-status-user-error;
            font-size: $little-font-size;
            line-height: 14px;
            text-indent: 8px;
            transform: scale(0.833);
            transform-origin: left bottom;
            &::before {
              position: absolute;
              top: 5px;
              left: 0;
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background-color: $color-status-user-error;
              content: '';
            }
          }
        }
        .input-error-empty {
          height: 15px;
        }
        .input-rate {
          margin-top: 15px;
          .rate-header {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            padding-left: 10px;
            @include border-bottom;
            .rate-left {
              display: flex;
              flex-direction: row;
              align-items: center;
              img {
                width: 25px;
                height: 17px;
                margin-right: 10px;
              }
              p {
                color: $color-stage5;
                font-size: $span-font-size;
                line-height: 20px;
              }
            }
            img.rate-right {
              width: 24px;
              height: 24px;
            }
          }
          .rate-footer {
            padding: 6px 10px 0;
            p {
              margin-bottom: -2.8px;
              color: $color-stage5;
              font-size: 12px;
              line-height: 16.8px;
              transform: scale(0.833);
              transform-origin: left top;
            }
          }
        }
        .due-date-wrapper {
          display: flow-root;
          .due-date {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 24px;
            margin-top: 30px;
            margin-bottom: 10px;
            img {
              width: 24px;
              height: 24px;
            }
            img.no-active {
              opacity: 0.5;
            }
            p {
              margin: 0 11px;
              color: $color-text;
              font-size: $h5-font-size;
              line-height: 18px;
              text-align: center;
              @include font-Medium;
            }
          }
        }
      }
      .confirm-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 44px;
        margin-top: 20px;
        border-radius: 4px;
        background-color: $color-primary;
        p {
          color: $color-bg-white;
          font-size: $base-font-size;
          line-height: 16px;
          text-align: center;
          @include font-Semibold;
        }
      }
      .confirm-btn-more {
        margin-top: 30px;
      }
      .comfirm-disabled {
        opacity: 0.5;
      }
    }
  }
}
</style>
